import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { keysUniversal, keys } from '../../resources/keys.resources';
import { Observable } from 'rxjs';
import { StoreServiceLibrary } from '../store/store.service';
import { CryptoService } from '../crypto/crypto.service';
import { AlleCoreRestInterface } from '../alle-core/alle-core-rest.interface';
import { AlleCoreRest } from '../alle-core/alle-core-rest.service';

@Injectable({
    providedIn: 'root'
})
export class GetJWTTokenService {

    constructor(
        private http: HttpClient,
        private store: StoreServiceLibrary,
        private alleCoreRest: AlleCoreRest,
        private cryptoService: CryptoService
    ) {
    }

    // getJWTToken() {
    //     const urlFinal = this.store.getJustOneUniversalPropertie(keysUniversal.viajes_api_url_get_jwt_token);
    //     let body = {
    //         username: this.store.getJustOneUniversalPropertie(keysUniversal.viajes_api_url_get_jwt_us)
    //         password: this.store.getJustOneUniversalPropertie(keysUniversal.viajes_api_url_get_jwt_pw)
    //     }
    //     // console.log('%c testing body', 'background:red; color:white', body);
    //     return this.http.post<GetJWTTokenResponse>(urlFinal, body);
    // }

    /**
     * Aplica para Auth - CreditCard - Unique
     * @param url for json web token
     * @param us user name
     * @param pw pass 
     */
    getJwtGeneral(url, us, pw, key?, fpjwt?): Observable<any> {
        let header = new HttpHeaders({
            'Content-Type': 'application/json'
        });
        let requestJwt = {
            username: us,
            password: pw
        };
        let objectRequest: AlleCoreRestInterface = {
            header: header,
            request: requestJwt,
            response: null,
            url,
            bearerToken: null,
            keyServicesSsl: key,
            fpjwt
        };
        return this.alleCoreRest.callService(objectRequest);
    }

    /**
     * Aplica para Auth - CreditCard - Unique
     * @param url for json web token
     * @param us user name
     * @param pw pass
     */
    getJwtGeneralCrypt(url, us, pw, key?, fpjwt?, isUniversal = false, passReq?, passResp?): Observable<any> {
        let header = new HttpHeaders({
            'Content-Type': 'application/json'
        });
        let requestJwt = {
            username: us,
            password: pw
        };
        let objectRequest: AlleCoreRestInterface = {
            header: header,
            request: requestJwt,
            response: null,
            url,
            bearerToken: null,
            keyServicesSsl: key,
            fpjwt
        };
        let content = this.cryptoService.generateRequest(requestJwt, true);
        if (isUniversal) {
            content = this.cryptoService.generateRequest(requestJwt, true, true, passReq);
        }
        const encryptedRequest: any = {
            content
        }
        objectRequest.request = encryptedRequest;
        return new Observable((observer) => {
            this.alleCoreRest.callService(objectRequest).subscribe((jwtTokenEnc: any) => {
                let respEncrypt;
                if (isUniversal) {
                    respEncrypt = this.cryptoService.convertResponse(jwtTokenEnc, true, true, passResp);
                } else {
                    respEncrypt = this.cryptoService.convertResponse(jwtTokenEnc, true);
                }
                let jwtToken;
                try {
                    // jwtToken = JSON.parse(respEncrypt);
                    jwtToken = respEncrypt;
                } catch (error) {
                    jwtToken = null;
                }
                observer.next(jwtToken);
                observer.complete();
            }, (err) => {
                observer.error(err);
                observer.complete();
            });
        });
    }

    getJwtAuth(useJwtToken) {
        const url = this.store.getJustOneUniversalPropertie(keysUniversal.AUTH_API_GET_JWTTOKEN_URL_V2);
        const un = this.store.getJustOneUniversalPropertie(keysUniversal.AUTH_API_GET_JWTTOKEN_UN);
        const pw = this.store.getJustOneUniversalPropertie(keysUniversal.AUTH_API_GET_JWTTOKEN_PW);
        if (useJwtToken) {
            return this.getJwtGeneralCrypt(url, un, pw, keysUniversal.AUTH_API_GET_JWTTOKEN_URL_V2);
        } else {
            return new Observable((observer) => {
                observer.next(null);
                observer.complete();
            });
        }
    }

    setJwtTokenAuth(useJwtToken): Observable<String> {
        return new Observable<String>((observer) => {
            this.getJwtAuth(useJwtToken).subscribe((jwtToken: string) => {
                this.store.setItemInStorage(keys.key_jwt_auth_general, jwtToken);
                observer.next(jwtToken);
                observer.complete();
            }, (err) => {
                console.error(err);
                observer.error(err);
                observer.complete();
            });
        });
    }
}
